import React from 'react';

import { Box, H3, Separator } from '@betterment/samba-react';

type ModalSectionProps = {
  header?: string;
  cta?: React.JSX.Element;
};

export const ModalSection: React.FC<React.PropsWithChildren<ModalSectionProps>> = ({ children, header, cta }) => {
  return (
    <Box
      css={{
        display: 'grid',
        gap: 'space.300',
        padding: 'space.300',
        border: 'token(borderWidths.thin) solid token(colors.border)',
        borderRadius: 'large',
      }}
    >
      {header && (
        <>
          <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
            <H3 variant="title200">{header}</H3>
            {cta}
          </Box>
          <Separator />
        </>
      )}
      <Box css={{ display: 'grid', gap: 'space.200' }}>{children}</Box>
    </Box>
  );
};
